export default __webpack_public_path__ + "static/media/effect_05.6639023e.png";